import { FaWhatsapp } from 'react-icons/fa'
import { whatsappLink } from '@/data/hotel'

function WhatsAppButton() {
  return (
    <a
      href={whatsappLink('Olá! Gostaria de mais informações sobre o Star Hotel.')}
      target="_blank"
      rel="noopener noreferrer"
      className="group fixed right-5 bottom-5 z-30 flex items-center md:right-8 md:bottom-8"
      aria-label="Conversar no WhatsApp"
    >
      <span className="mr-3 hidden translate-x-2 rounded-full bg-card px-4 py-2 text-sm font-medium text-card-foreground opacity-0 shadow-lg ring-1 ring-foreground/10 transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-100 md:inline-block">
        Fale conosco
      </span>
      <span className="relative flex size-14 items-center justify-center rounded-full bg-whatsapp text-whatsapp-foreground shadow-lg transition-transform duration-300 group-hover:scale-105">
        <span className="absolute inline-flex size-full animate-ping rounded-full bg-whatsapp opacity-40" />
        <FaWhatsapp className="relative size-7" />
      </span>
    </a>
  )
}

export default WhatsAppButton
